// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".-col-group{display:inline-block;margin-bottom:5px;padding:0;width:150px;vertical-align:top}.-col-group-title{display:block;margin:5px;padding:5px;border-bottom:1px solid #ddd;font-size:18px}.-col-group>li{margin-bottom:5px;padding-left:10px;list-style:none;line-height:20px;font-size:12px}.-col-group>li>*{margin:0;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
